import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessBuildings } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canManageBuildings } from "@/helpers/permissions";

import { BuildingListPage } from "./pages/BuildingListPage";
import { CreateBuildingPage } from "./pages/CreateBuildingPage";
import { EditBuildingPage } from "./pages/EditBuildingPage";
import { buildingRoutes } from "./routes";

export const buildingsRoute = [
  {
    path: buildingRoutes.list,
    element: (
      <RequireAuth permission={canAccessBuildings}>
        <BuildingListPage />
      </RequireAuth>
    ),
  },
  {
    path: buildingRoutes.new,
    element: (
      <RequireAuth permission={canManageBuildings}>
        <CreateBuildingPage />
      </RequireAuth>
    ),
  },
  {
    path: buildingRoutes.edit,
    element: (
      <RequireAuth permission={canManageBuildings}>
        <EditBuildingPage />
      </RequireAuth>
    ),
  },
  {
    path: "*",
    element: <ErrorPage status={404} />,
  },
] satisfies RouteObject[];
